import AbstractFilter from '@/classes/filters/AbstractFilter'

export default class Filter extends AbstractFilter {
  /**
   * Create new filter
   *
   * @param {String} key
   * @param {String} property
   * @param {String} [value]
   */
  constructor (key, property, value) {
    super(key, null, property, value)
  }
}
